import { resolveNumericFacilityId } from '@/core/services/api/weightloss-inventory/facility'
import {
  getErrorMessage,
  getValidationErrors,
  buildListQueryParams,
} from '@/core/services/api/weightloss-inventory/helpers'

export default {
  data() {
    return {
      loading: false,
      items: [],
      perPage: 10,
      perPageOptions: [10, 25, 50, 100].map(i => ({
        id: i,
        label: `Show ${i}`,
      })),
      dataMeta: { from: 0, to: 0, of: 0 },
      totalUsers: 0,
      currentPage: 1,
      facilityId: '',
    }
  },
  created() {
    this.facilityId = resolveNumericFacilityId()
  },
  methods: {
    facilityParams() {
      if (!this.facilityId || !/^\d+$/.test(String(this.facilityId))) return {}
      return { facility_id: this.facilityId }
    },
    buildListQueryParams(filters = {}) {
      return buildListQueryParams(filters)
    },
    applyPagination(res) {
      this.items = res.items
      this.totalUsers = res.total
      this.dataMeta = { from: res.from, to: res.to, of: res.total }
      this.currentPage = res.current_page
    },
    handleApiError(err, toast) {
      const errors = getValidationErrors(err)
      if (errors && toast) {
        const msg = Object.entries(errors)
          .map(([k, v]) => `${k}: ${Array.isArray(v) ? v[0] : v}`)
          .join('; ')
        toast.danger(msg || getErrorMessage(err))
      } else if (toast) {
        toast.danger(getErrorMessage(err))
      }
    },
  },
}
